import {
  SimpleForm,
  TextInput,
  Create,
  Datagrid,
  List,
  TextField,
  SelectInput,
} from 'react-admin'

export const BlacklistStoreList = () => (
  <List>
    Stores in this list will not be displayed on map in Discount app.
    <br />
    <br />
    <Datagrid rowClick="edit">
      <TextField source="storeKey" />
      <TextField source="storeName" />
      <TextField source="storeDescription" />
      <TextField source="thirdParty" />
    </Datagrid>
  </List>
)

export const BlacklistStoreForm = () => (
  <SimpleForm maxWidth={700}>
    <TextInput source="storeKey" required/>
    <TextInput source="storeName" required/>
    <TextInput source="storeDescription" required/>
    <SelectInput source="thirdParty" required choices={[
      { id: 'Access', name: 'Access' },
      { id: 'Entertainment', name: 'Entertainment' },
    ]} />
  </SimpleForm>
)

// export const BlacklistStoreEdit = () => {
//   return (
//     <Edit>
//       <BlacklistStoreForm />
//     </Edit>
//   )
// }

export const BlacklistStoreCreate = () => {
  return (
    <Create>
      <BlacklistStoreForm />
    </Create>
  )
}
